export enum ValidationResultEnum {
    SuccessFull = 0,
    MinimumExceeded = 1,
    MaximumNumberExceeded = 2,
    FieldIsRequired = 3,
    InvalidUrl = 4
}